<template>
  <section class="terms__background-recuse-terms" @click="closeActionComponent">
    <div class="terms__alert-recuse-terms">
      <img src="../../../public/images/close.svg" class="terms__button-close" @click="closeActionComponent">

      <div class="terms_alert-header">
        <img src="../../../public/images/warning.svg" class="terms__alert-header-attention">

        <h2 class="terms_alert-header-title">Recusar termos</h2>

      </div>
      <span class="information__recuse">
        Ao recusar os termos de uso, você não poderá mais receber rotas.
      </span>
      <hr class="terms__line-alert">
      <div class="options__recuse-cancel">
        <button class="options option__cancel" @click="closeActionComponent">
          Cancelar
        </button>
        <button class="options option__recuse" @click="refuseActionComponent">
          Recusar
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useRouter } from 'vue-router';

const emit = defineEmits(['close', 'reject']);
const router = useRouter();

function closeActionComponent() {
  emit('close');
}

function refuseActionComponent() {
  emit('reject');
}
</script>

<style lang="scss">
  .terms__background-recuse-terms{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1001;
    background-color: #00000054;
  }

  .terms__alert-recuse-terms{
    background-color: #F6F6F6;
    width: 80vw;
    padding: 5vw;
    display: flex;
    justify-content: start;
    flex-direction: column;
    border-radius: 8px;
  }

  .terms__button-close{
    width: 28px;
    margin: 5px 0 5px auto;
    cursor: pointer;
  }

  .terms_alert-header{
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 5px;
    margin-bottom: 20px;
  }


  .terms_alert-header-title{
    font-size: 22px;
    color: #D81F47;
  }

  .information__recuse{
    font-size: 20px;
  }

  .terms__line-alert{
    width: 100%;
    margin: 20px 0 10px;
    color: #C5D1E2;
  }

  .options__recuse-cancel{
    width: 100%;
    display: flex;
    justify-content: space-evenly;
    margin: 18px 0;
  }

  .options{
    font-size: 18px;
    font-weight: 400;
    cursor: pointer;
  }

  .option__recuse{
    color: var(--color-text-sec-danger);
  }
</style>
